export default __webpack_public_path__ + "media/zurb/img/ecommerce/product_page-00ec46398950046ee8b50be2aba682f9.png";